import { keyMirror } from 'redfish-core/lib/utils/utils'

export const actionTypes = keyMirror([
    'START_QR_SCAN',
    'QR_SCAN_RESULT',
    'STOP_QR_SCAN',
])
